import React, { useEffect, useState, useCallback } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import SendIcon from "@mui/icons-material/Send";
import { ProfitAndLossPDFAPi } from "./ProfitLossAction";
import { setHeading } from "../../../accounts/account.actions";
import { startFinancialDate, endFinancialDate } from "../../../../../global/globalFunctions";


const ViewProfitLoss = ({ ProfitAndLossPDFAPi, setHeading }) => {
    const [startDate, setStartDate] = useState(startFinancialDate);
    const [endDate, setEndDate] = useState(endFinancialDate);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setHeading("Profit and Loss");
    }, [setHeading]);

    const handleExportPDF = useCallback(async () => {
        if (!startDate || !endDate || isLoading) return;

        setIsLoading(true);
        try {
            await ProfitAndLossPDFAPi({ startDate, endDate });
        } catch (error) {
            console.error("Failed to generate Profit & Loss PDF:", error);
            alert("Unable to generate the report. Please try again.");
        } finally {
            setIsLoading(false);
        }
    }, [startDate, endDate, isLoading, ProfitAndLossPDFAPi]);

    const isDisabled = isLoading || !startDate || !endDate;

    return (
        <Container fluid>
            <Row>
                <Col>
                    <Form.Group>
                        <Form.Label><b>Start Date *</b></Form.Label>
                        <Form.Control
                            type="date"
                            value={startDate}
                            max={endDate || undefined}
                            onChange={(e) => setStartDate(e.target.value)}
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label><b>End Date *</b></Form.Label>
                        <Form.Control
                            type="date"
                            value={endDate}
                            min={startDate || undefined}
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                    </Form.Group>
                </Col>
            </Row>

            <div className="sendDiv" style={{ marginTop: "35px" }}>
                <Button
                    variant="contained"
                    size="large"
                    disabled={isDisabled}
                    onClick={handleExportPDF}
                    endIcon={isLoading ? (<CircularProgress size={20} color="inherit" />) : (<SendIcon />)}
                >
                    <b>{isLoading ? "GENERATING..." : "PROFIT AND LOSS PDF"}</b>
                </Button>
            </div>
        </Container>
    );
};

const mapDispatchToProps = (dispatch) => ({
    ProfitAndLossPDFAPi: (data) => dispatch(ProfitAndLossPDFAPi(data)),
    setHeading: (data) => dispatch(setHeading(data)),
});

export default connect(null, mapDispatchToProps)(ViewProfitLoss);